import angular from 'angular';

angular.module('cloudX').directive('selectOnFocus', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var focusedElement = null;
        var onFocus = function() {
          var self = this;
          if (focusedElement !== self) {
            focusedElement = self;
            $timeout(function() {
              if (focusedElement) focusedElement.select();
            }, 10);
          }
        };
        var onBlur = function() {
          focusedElement = null;
        };

        element.on('focus', onFocus);
        element.on('blur', onBlur);

        //Cleanup events if the element is destroyed
        element.on('$destroy', function() {
          element.off('focus', onFocus);
          element.off('blur', onBlur);
          focusedElement = null;
        });
      },
    };
  },
]);
